<template>
  <div class="card">
    <div
      v-if="this.errosValidacaoGeral.length"
      class="notice d-flex bg-light-danger rounded border-danger border border-dashed mx-9 mt-9 p-6"
    >
      <span class="svg-icon svg-icon-2tx svg-icon-danger me-4">
        <inline-svg src="media/icons/duotune/general/gen044.svg" />
      </span>
      <div class="d-flex flex-stack flex-grow-1">
        <div class="fw-bold">
          <h4 class="text-gray-800 fw-bolder">Aviso</h4>
          <div class="fs-6 text-gray-600">
            <ul>
              <li v-for="value in this.errosValidacaoGeral" :key="value">
                {{ value }}
              </li>
            </ul>
          </div>
        </div>
      </div>
      <button
        type="button"
        class="position-absolute position-sm-relative m-2 m-sm-0 top-0 end-0 btn btn-icon ms-sm-auto"
        @click="this.errosValidacaoGeral = {}"
      >
        <span class="svg-icon svg-icon-2x">
          <img src="media/icons/duotune/arrows/arr088.svg" />
        </span>
      </button>
    </div>
    <div class="card-header">
      <h3 class="card-title">
        <img
          src="media/icons/duotune/abstract/abs039.svg"
          class="me-2"
        />Bloqueio
      </h3>
      <div
        v-if="this.modal === true"
        class="btn btn-icon btn-sm btn-active-light-primary mt-6"
        data-bs-dismiss="modal"
        @click="this.$emit('fecharBloqueioLicenca', false)"
      >
        <span class="svg-icon svg-icon-2x">
          <img src="media/icons/duotune/arrows/arr061.svg" />
        </span>
      </div>
    </div>
    <div class="card-body p-0">
      <div class="card-header border-0 pt-5">
        <div class="card-title">
          <div class="d-flex align-items-center position-relative my-1">
            <span class="svg-icon svg-icon-1 position-absolute ms-6">
              <inline-svg src="media/icons/duotune/general/gen004.svg" />
            </span>
            <input
              id="txtPesquisar"
              type="text"
              v-model="tableData.search"
              @input="onInput"
              class="form-control form-control-solid w-250px ps-15"
              placeholder="Pesquisar"
            />
          </div>
        </div>
        <div class="card-toolbar flex-row-fluid justify-content-end gap-5">
          <button
            v-if="this.adicionar"
            type="button"
            class="btn btn-sm btn-primary"
            @click="this.adicionarBloqueioLicenca()"
          >
            <span class="svg-icon svg-icon-1">
              <inline-svg src="media/icons/duotune/general/gen041.svg" /></span
            >Adicionar
          </button>
        </div>
      </div>
      <div class="card-body pt-0">
        <Datatable
          ref="table"
          :table-header="tableHeader"
          :table-data="tableData"
          :table-pagination="tablePagination"
          :page-sizes="pageSizes"
          :enable-items-per-page-dropdown="true"
          :hide-on-single-page="false"
          empty-table-text="Nenhum registro foi encontrado"
          @checked-rows="checked = $event"
          :colors="true"
        >
          <template v-slot:cell-id="{ row: data }">
            {{ data.id }}
          </template>
          <template v-slot:cell-nome="{ row: data }">
            <div class="min-w-150px align-middle">
              <div
                class="text-muted text-hover-primary fw-semibold text-muted d-block fs-9"
              >
                <span>
                  {{ getDescricaoRelacionado(data) }}
                </span>
              </div>
              <div class="text-gray-900 fw-bold text-hover-primary mb-1 fs-6">
                <span>
                  {{ getNomeRelacionado(data) }}
                </span>
              </div>
              <div
                class="text-muted text-hover-primary fw-semibold text-muted d-block fs-7"
              >
                <span>
                  {{
                    this.$utils.setMask(
                      getDocumentoRelacionado(data),
                      "##.###.###/####-##",
                      true
                    )
                  }}
                </span>
              </div>
              <div
                class="mt-1"
                v-if="data && data.Emitente && data.Emitente.Revenda"
              >
                <div class="text-primary fw-semibold d-block fs-9">
                  <span>
                    Revenda ({{
                      data.Emitente.Revenda.id +
                      " - " +
                      data.Emitente.Revenda.nome
                    }})
                  </span>
                </div>
              </div>
            </div>
          </template>
          <template v-slot:cell-motivo="{ row: data }">
            <div
              class="min-w-150px text-gray-800 text-muted text-hover-primary fw-semibold text-muted d-block fs-7"
            >
              <div>
                {{ data.motivo }}
              </div>
            </div>
          </template>
          <template v-slot:cell-createdAt="{ row: data }">
            <div class="min-w-100px">
              <div>
                {{ this.$utils.formatarData(data.createdAt) }}
              </div>
            </div>
          </template>
          <template v-slot:cell-updatedAt="{ row: data }">
            <div
              class="min-w-100px text-gray-900 fw-bold text-hover-primary d-block mb-1 fs-6"
            >
              <div>
                {{ this.$utils.formatarData(data.updatedAt) }}
              </div>
            </div>
          </template>
          <template v-slot:cell-acoes="{ row: data }">
            <div
              class="d-flex flex-row-fluid justify-content-end flex-shrink-0 gap-3"
            >
              <button
                class="btn btn-sm btn-light btn-active-light-primary"
                data-kt-menu-trigger="click"
                data-kt-menu-placement="bottom-end"
                data-kt-menu-flip="top-end"
              >
                Ações
                <span class="svg-icon svg-icon-5 m-0">
                  <inline-svg src="media/icons/duotune/arrows/arr072.svg" />
                </span>
              </button>
              <div
                v-if="this.editar || this.excluir"
                class="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold fs-7 w-150px py-4"
                data-kt-menu="true"
              >
                <div v-if="this.editar" class="menu-item px-3">
                  <a @click="editarRegistro(data.id)" class="menu-link px-3"
                    ><span class="svg-icon svg-icon-1 align-self-center">
                      <inline-svg
                        src="media/icons/duotune/art/art005.svg"
                        class="me-2"
                      />Editar
                    </span></a
                  >
                </div>
                <div v-if="this.excluir" class="menu-item px-3">
                  <a @click="removerRegistro(data)" class="menu-link px-3"
                    ><span class="svg-icon svg-icon-1 align-self-center">
                      <inline-svg
                        src="media/icons/duotune/arrows/arr015.svg"
                        class="me-2"
                      />Excluir
                    </span></a
                  >
                </div>
              </div>
            </div>
          </template>
        </Datatable>
      </div>
    </div>
  </div>
  <EditarBloqueioModal
    v-if="exibirModalEditarBloqueioLicenca"
    :id="this.idBloqueioLicenca"
    @exibirEditarBloqueioLicencaModal="exibirEditarBloqueioLicencaModal"
    @confirmarEditarBloqueioLicencaModal="confirmarEditarBloqueioLicencaModal"
  ></EditarBloqueioModal>
</template>

<script>
import { getOrCreateInstanceModal, hideModalId } from "@/core/helpers/dom";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import Datatable from "@/components/kt-datatable/KTDatatableCustom.vue";
import { mapState } from "vuex";
import { useToast } from "vue-toastification";
import EditarBloqueioModal from "@/views/licencarecebivel/EditarBloqueioModal.vue";

const toast = useToast();

export default {
  emits: ["selecionarBloqueioLicenca", "fecharBloqueioLicenca"],
  components: {
    Datatable,
    EditarBloqueioModal,
  },
  props: {
    modal: { type: Boolean, required: false, default: false },
  },
  computed: {
    ...mapState("auth", ["user"]),
  },
  methods: {
    loadData() {
      this.tableData.search = "";
      this.tablePagination.page = 1;
      this.tablePagination.rowsPerPage = 10;
      this.$refs.table.setRowsPage(10);
      this.tableData.filterOData = "";
      this.$refs.table.load();
    },

    onInput() {
      clearTimeout(this.typingTimer);
      this.typingTimer = setTimeout(() => {
        this.onSearch(this.tableData.search);
      }, this.doneTypingInterval);
    },

    async onSearch(pesquisa) {
      if (pesquisa !== "") {
        pesquisa = pesquisa.replace("'", "''");
        this.tableData.filterOData =
          "&$filter=(contains(motivo, '" +
          pesquisa +
          "') or contains(Revenda/nome, '" +
          pesquisa +
          "') or contains(Revenda/cnpj, '" +
          this.$utils.unMask(pesquisa) +
          "') or contains(Revenda/fantasia, '" +
          pesquisa +
          "') or contains(Emitente/nome, '" +
          pesquisa +
          "') or contains(Emitente/cnpj, '" +
          this.$utils.unMask(pesquisa) +
          "') or contains(Emitente/fantasia, '" +
          pesquisa +
          "') or contains(Distribuidor/nome, '" +
          pesquisa +
          "') or contains(Distribuidor/cnpj, '" +
          this.$utils.unMask(pesquisa) +
          "') or contains(Distribuidor/fantasia, '" +
          pesquisa +
          "') or contains(DistribuidorMaster/nome, '" +
          pesquisa +
          "') or contains(DistribuidorMaster/cnpj, '" +
          this.$utils.unMask(pesquisa) +
          "') or contains(DistribuidorMaster/fantasia, '" +
          pesquisa +
          "') ";
        if (this.$utils.isNumber(pesquisa)) {
          this.tableData.filterOData =
            this.tableData.filterOData + " or id eq " + pesquisa;
        }
        this.tableData.filterOData += ")";
      } else {
        this.tableData.filterOData = "";
      }
      this.filtroAplicado = this.tableData.filterOData;
    },
    async removerRegistro(data) {
      await this.$swal.showQuestionAlert(
        "Deseja remover o registro?",
        async (alert) => {
          if (alert.isConfirmed) {
            this.errosValidacaoGeral = [];
            this.excluiu = true;
            this.$refs.table.setLoading(true);
            try {
              await this.$store.dispatch(
                "bloqueioLicenca/deleteBloqueioLicenca",
                data.id
              );
            } catch (error) {
              this.excluiu = false;
              this.errosValidacaoGeral.push(error.Message);
            }
            if (this.excluiu === true) {
              toast.success("Registro excluído com sucesso!", {
                timeout: 3000,
              });
            }
            this.$refs.table.load();
          }
        }
      );
    },

    nextFocus(id) {
      if (document.getElementById(id) != null) {
        document.getElementById(id).focus();
      }
    },

    async verificarRestricoes() {
      if (this.user.User.TipoUsuario.Restricao != null) {
        this.user.User.TipoUsuario.Restricao.find((element) => {
          if (element.regra === "Permitir.BloqueioLicenca.Incluir") {
            this.adicionar = true;
          }
          if (element.regra === "Permitir.BloqueioLicenca.Alterar") {
            this.editar = true;
          }
          if (element.regra === "Permitir.BloqueioLicenca.Excluir") {
            this.excluir = true;
          }
        });
      }
    },

    getDescricaoRelacionado(data) {
      if (data.Revenda) {
        return "Revenda";
      } else if (data.Emitente) {
        return "Emitente";
      } else if (data.Distribuidor) {
        return "Distribuidor";
      } else if (data.DistribuidorMaster) {
        return "Distribuidor Master";
      } else {
        return "";
      }
    },

    getNomeRelacionado(data) {
      if (data.Revenda) {
        return data.Revenda.nome;
      } else if (data.Emitente) {
        return data.Emitente.nome;
      } else if (data.Distribuidor) {
        return data.Distribuidor.nome;
      } else if (data.DistribuidorMaster) {
        return data.DistribuidorMaster.nome;
      } else {
        return "";
      }
    },

    getDocumentoRelacionado(data) {
      if (data.Revenda) {
        return data.Revenda.cnpj;
      } else if (data.Emitente) {
        return data.Emitente.cnpj;
      } else if (data.Distribuidor) {
        return data.Distribuidor.cnpj;
      } else if (data.DistribuidorMaster) {
        return data.DistribuidorMaster.cnpj;
      } else {
        return "";
      }
    },

    async atualizarTabela() {
      this.$refs.table.setLoading(true);
      this.$refs.table.load();
    },

    async confirmarEditarBloqueioLicencaModal() {
      await this.atualizarTabela();
      this.exibirModalEditarBloqueioLicenca = false;
    },

    exibirEditarBloqueioLicencaModal(exibir) {
      this.exibirModalEditarBloqueioLicenca = exibir;
      if (exibir === true) {
        getOrCreateInstanceModal(
          "kt_modal_bloqueio_licenca_editar",
          /*open*/ () => {
            this.$utils.requestFocus("txtMotivo");
          },
          /*close*/ () => {
            this.exibirEditarBloqueioLicencaModal(false);
          }
        );
      }
    },

    async adicionarBloqueioLicenca() {
      const hoje = new Date();
      const dia = hoje.getDate();
      if (
        dia >= 10 &&
        dia <= 15 &&
        this.user.User.TipoUsuario.tipo !== "Administrador"
      ) {
        await this.$swal.showInvalidAlert(
          "Não é possível adicionar um bloqueio entre o dia 10 e 15. Se precisar bloquear um cliente definitivamente, entre em contato com o setor financeiro!"
        );
      } else {
        this.idBloqueioLicenca = -1;
        this.exibirEditarBloqueioLicencaModal(true);
      }
    },

    editarRegistro(id) {
      this.idBloqueioLicenca = id;
      this.exibirEditarBloqueioLicencaModal(true);
    },
  },
  async mounted() {
    setTimeout(() => {
      this.nextFocus("txtPesquisar");
    }, 500);
    await this.verificarRestricoes();
  },
  data() {
    return {
      adicionar: false,
      editar: false,
      excluir: false,
      errosValidacaoGeral: [],
      loading: false,
      idBloqueioLicenca: -1,
      exibirModalEditarBloqueioLicenca: false,
      tableHeader: [
        {
          name: "ID",
          key: "id",
          sortable: true,
        },
        {
          name: "Nome",
          key: "nome",
          sortable: false,
          sortingField: "Revenda/nome",
        },
        {
          name: "Motivo",
          key: "motivo",
          sortable: true,
        },
        {
          name: "Data Inclusão",
          key: "createdAt",
          sortable: true,
        },
        {
          name: "Data Alteração",
          key: "updatedAt",
          sortable: true,
        },
        {
          name: "Ações",
          key: "acoes",
          sortable: false,
        },
      ],
      tableData: {
        store: "bloqueioLicenca/getBloqueioLicencaOData",
        selectOData:
          "?$select=id,motivo,createdAt,updatedAt&$expand=Revenda($select=id,nome,cnpj)&$expand=Emitente($select=id,nome,cnpj;$expand=Revenda($select=id,nome))&$expand=Distribuidor($select=id,nome,cnpj)&$expand=DistribuidorMaster($select=id,nome,cnpj)",
        filterOData: "",
        search: "",
        defaultSort: "id desc, createdAt desc",
      },
      tablePagination: {
        page: 1,
        rowsPerPage: 10,
      },
      pageSizes: ["5", "10", "15", "20", "30", "50", "100", "Todos"],
    };
  },
};
</script>

<style></style>
